import type { MDXComponents } from "mdx/types";
import Link from "ui/components/Link";
import styles from "./MdxComponents.module.scss";

const components: MDXComponents = {
  h1: ({ children }) => <h1 className={styles.h1}>{children}</h1>,
  h2: ({ children }) => <h2 className={styles.h2}>{children}</h2>,
  h3: ({ children }) => <h3 className={styles.h3}>{children}</h3>,
  h4: ({ children }) => <h4 className={styles.h4}>{children}</h4>,
  h5: ({ children }) => <h5 className={styles.h5}>{children}</h5>,
  h6: ({ children }) => <h6 className={styles.h6}>{children}</h6>,
  p: ({ children }) => <p className={styles.p}>{children}</p>,
  ul: ({ children }) => <ul>{children}</ul>,
  ol: ({ children }) => <ol>{children}</ol>,
  li: ({ children }) => <li>{children}</li>,
  a: ({ children, href }) => (
    <Link className={styles.link} href={href}>
      {children}
    </Link>
  ),
  img: ({ src, alt }) => <img src={src} alt={alt} />,
  code: ({ children }) => <code>{children}</code>,
  pre: ({ children }) => <pre>{children}</pre>,
  blockquote: ({ children }) => <blockquote>{children}</blockquote>,
  hr: () => <hr className={styles.hr} />,
};

/**
 * Provides custom React components for MDX rendering.
 * Components defined here will be used to render corresponding MDX elements.
 */
export default function useMDXComponents(): MDXComponents {
  return components;
}
